export const COLOR_PALETTE = [
  'current',
  'transparent',
  'white',
  'black',
  'gray.50',
  'gray.100',
  'gray.200',
  'gray.300',
  'gray.400',
  'gray.500',
  'gray.600',
  'gray.700',
  'gray.800',
  'gray.900',
  'gray.950',
  'violet.50',
  'violet.100',
  'violet.200',
  'violet.300',
  'violet.400',
  'violet.500',
  'violet.600',
  'violet.700',
  'violet.800',
  'violet.900',
  'violet.950',
  'pink.50',
  'pink.100',
  'pink.200',
  'pink.300',
  'pink.400',
  'pink.500',
  'pink.600',
  'pink.700',
  'pink.800',
  'pink.900',
  'pink.950',
  'blue.50',
  'blue.100',
  'blue.200',
  'blue.300',
  'blue.400',
  'blue.500',
  'blue.600',
  'blue.700',
  'blue.800',
  'blue.900',
  'blue.950',
  'red.50',
  'red.100',
  'red.200',
  'red.300',
  'red.400',
  'red.500',
  'red.600',
  'red.700',
  'red.800',
  'red.900',
  'red.950',
  'orange.50',
  'orange.100',
  'orange.200',
  'orange.300',
  'orange.400',
  'orange.500',
  'orange.600',
  'orange.700',
  'orange.800',
  'orange.900',
  'orange.950',
  'yellow.50',
  'yellow.100',
  'yellow.200',
  'yellow.300',
  'yellow.400',
  'yellow.500',
  'yellow.600',
  'yellow.700',
  'yellow.800',
  'yellow.900',
  'yellow.950',
  'green.50',
  'green.100',
  'green.200',
  'green.300',
  'green.400',
  'green.500',
  'green.600',
  'green.700',
  'green.800',
  'green.900',
  'green.950',
  'olive.50',
  'olive.100',
  'olive.200',
  'olive.300',
  'olive.400',
  'olive.500',
  'olive.600',
  'olive.700',
  'olive.800',
  'olive.900',
  'olive.950',
  'cyan.50',
  'cyan.100',
  'cyan.200',
  'cyan.300',
  'cyan.400',
  'cyan.500',
  'cyan.600',
  'cyan.700',
  'cyan.800',
  'cyan.900',
  'cyan.950',
  'cornflower.50',
  'cornflower.100',
  'cornflower.200',
  'cornflower.300',
  'cornflower.400',
  'cornflower.500',
  'cornflower.600',
  'cornflower.700',
  'cornflower.800',
  'cornflower.900',
  'cornflower.950',
  'magenta.50',
  'magenta.100',
  'magenta.200',
  'magenta.300',
  'magenta.400',
  'magenta.500',
  'magenta.600',
  'magenta.700',
  'magenta.800',
  'magenta.900',
  'magenta.950'
] as const;

export const COLOR_PROPS_TYPE = [
  'gray',
  'violet',
  'pink',
  'blue',
  'green',
  'yellow',
  'orange',
  'red',
  'olive',
  'cyan',
  'cornflower',
  'magenta',
  'white'
] as const;

export type ColorPalette = (typeof COLOR_PALETTE)[number];
export type ColorPropsType = (typeof COLOR_PROPS_TYPE)[number];
